<template lang="pug">
v-container(fluid )
    RatingDialog(v-if="showRatingDialog" :show="showRatingDialog" :ratingDeliveryTimeData="ratingDeliveryTimeData"
      :lastReservationDetailData="lastReservationDetailData" :selectedOfferRating="selectedOfferRating" @close="closeRatingDialog")
    v-dialog(v-if="showInfoDialog" v-model="showInfoDialog" width="1000px" persistent)
      v-card
        v-card-title {{ $t('orderPage.infoDialogTitle') }}
        v-card-text.pb-0
          v-row.ma-0
            v-col(cols="1")
              v-icon(v-if="reservationItem" :color="getColor" large) {{getConfig}}
            v-col(cols="11")
              span.title {{getLabel}}
          v-row.ma-0(v-if="isAcceptanceProcess && reservationItem && isReservationCanceled")
            v-col(cols="1")
              v-icon(large color="orange") {{getIcon}}
            v-col(cols="11")
              span.title {{getAcceptaceLabel}}
          v-row.ma-0
            v-col(cols="1")
              v-icon.btn-77(v-if="isSelectionChanged && isKioskMode || isTimeBlockChanged" large color="red") fas fa-exclamation-circle
            v-col(cols="11")
              span.title(v-if="isSelectionChanged && isKioskMode || isTimeBlockChanged") {{ $t('orderPage.dataChangedWarning') }}
          v-row.ma-0
            v-col(cols="1")
              v-icon(v-if="reservationItem.boarderNote !== null && isSelectionChanged && isKioskMode || isTimeBlockChanged" large color="primary") fas fa-info-circle
            v-col(cols="11")
              span.title(v-if="isSelectionChanged && isKioskMode || isTimeBlockChanged") {{ reservationItem.boarderNote }}
        v-card-actions
          v-spacer
          v-btn(color="primary" @click="showInfoDialog=false") {{ $t('errorResponseDialog.closeButtonLabel') }}
    v-row(v-if="!isKioskMode")
        v-col(v-if="allowSave" align="center")
            v-btn(
                color="primary" :disabled="isSaveButtonDisabled === false || isSubmitButtonDisabled === false ? false : true" :loading="saveInProgress"
                :min-height="saveButtonMinHeight" :min-width="saveButtonMinWidth"
                @click="onSaveButtonClick")
                v-icon.mr-1 {{ saveButtonIcon }}
                span {{ saveButtonLabel }}
        v-col(v-if="allowCancellation" align="center")
            v-btn(
                color="warning" max-width="100%"
                :disabled="isCancelButtonDisabled" :loading="cancellationInProgress"
                @click="onCancelButtonClick")
                v-icon.mr-1 fas fa-ban
                span {{ $t('orderPage.buttonCancel') }}
    v-row.ma-0.mb-0.my-9( v-else)
      v-col.text-start.pb-0.button-Style(cols="auto" align="center" justify="center" v-if="!isOfferEmpty")
        v-row.ma-0
          v-btn(v-if="reservationItem" :color="getColor" x-large  @click="showInformationDialog" icon)
            v-icon {{getConfig}}
          v-btn.ml-6(icon x-large  @click="showInformationDialog" color="orange" v-if="isAcceptanceProcess && reservationItem && isReservationCanceled")
            v-icon {{getIcon}}
          v-btn.ml-6(icon v-if="isSelectionChanged && isKioskMode && reservationItem || isTimeBlockChanged && reservationItem" x-large color="red" @click="showInformationDialog")
            v-icon.btn-77() fas fa-exclamation-circle
          v-btn.ml-6(icon v-if="reservationItem && reservationItem.boarderNote && reservationItem.boarderNote !== null &&  isKioskMode && reservationItem && reservationItem" x-large color="primary" @click="showInformationDialog")
            v-icon() fas fa-info-circle
          v-btn.ml-6(x-large v-if="isKioskMode && isDateTwoDaysBeforeToday" :class="getPulse" @click="showRatingDialogClick" icon color="success" :loading="isRefreshData")
            v-icon fas fa-smile
      v-spacer
      v-col.px-0.text-end.pl-12.pb-0.button-Style2(v-if="allowCancellation" cols="auto")
        v-btn.text-h5(
          height="50px"
          color="warning" large
          :disabled="isCancelButtonDisabled" :loading="cancellationInProgress"
          @click="onCancelButtonClick"
        )
          v-icon.mr-1 fas fa-ban
          span {{ $t('orderPage.buttonCancel') }}
      v-spacer
      v-col.px-0.text-end.pb-0.button-Style1(v-if="allowSave && !isOfferEmpty" cols="auto")
        v-btn.text-h5(
          height="50px"
          color="primary" :disabled="isSaveButtonDisabled === false || isSubmitButtonDisabled === false ? false : true" :loading="saveInProgress"
          large
          @click="onSaveButtonClick"
        )
          v-icon.mr-1 {{ saveButtonIcon }}
          span {{ saveButtonLabel }}


</template>

<script lang="ts">
import Vue from 'vue'
import MenuReservationItem from '@/model/MenuReservationItem'
import { TranslateResult } from 'vue-i18n'
import moment from 'moment'
import { getLocale } from '@/services/system'
import { ReservationStatus } from '@/types/enums'
import BusinessTimeBlockCollection from "@/model/TimeBlockCollection";
import {GET_MODE} from "@/store/getter-types";
import InfoMenuGroupItemDialog from "@/components/order/InfoMenuGroupItemDialog.vue";
import RatingDialog from "@/components/dashboard/RatingDialog.vue";
import {usePiniaStore} from "@/store/piniaStore";
import {RatingModel} from "@/model/RatingModel";
import Moment from "moment/moment";
import {formatFloatPrice} from "@/services/formatter";
import {FETCH_DASHBOARD} from "@/store/action-types";

interface Data {
  showInfoDialog: boolean,
  key: boolean,
  showRatingDialog: boolean,

}

export default Vue.extend({
  name: 'GroupControlButtons',
  components: {
    RatingDialog
  },

  data (): Data {
    return {
      showInfoDialog: false,
      key:true,
      showRatingDialog:false,
    }
  },

  props: {
    date: { type: Date, required: true },
    reservationItem: { type: Object as () => MenuReservationItem | undefined },
    timeBlockCollection: { type: Array as () => BusinessTimeBlockCollection[] | null },
    saveInProgress: { type: Boolean, default: false },
    cancellationInProgress: { type: Boolean, default: false },
    isSelectionChanged: { type: Boolean, default: false },
    isSubmitButtonDisabled: { type: Boolean, default: false },
    isOfferEmpty: { type: Boolean, default: false },
    isAcceptanceProcess: { type: Boolean, default: false },
    isTimeBlockChanged: { type: Boolean, default: false },
    isAmountChanged: { type: Boolean, required: true },
    ratingDeliveryTimeData: { type: Number, required: false },
    lastReservationDetailData:{ type: Array as () => any[] },
    selectedOfferRating:{type: Object as () => any | undefined },
    lastReservationNumber:{ type: Array as () => any[] },
    isRefreshData: { type: Boolean, default: false },

  },

  computed: {
    isDateTwoDaysBeforeToday(): boolean {
      let isDataForRating: boolean = false
      let dateCreatedString: string = ''
      if (this.selectedOfferRating && this.selectedOfferRating.createdAt) {
        dateCreatedString = this.selectedOfferRating.createdAt
        isDataForRating = true
      } else if (this.date) {
        dateCreatedString = this.date
        isDataForRating = true
      } else {
        if (this.lastReservationDetailData && this.lastReservationDetailData.length > 0) {
          dateCreatedString = this.lastReservationDetailData[0].createdAt
          isDataForRating = true
        } else {
          dateCreatedString = this.date
          isDataForRating = false
        }

      }
      return isDataForRating
    },

    getPulse (): string {
        return "pulse-button"
    },

    getAcceptaceLabel (): string {
      if (this.reservationItem && this.reservationItem.acceptanceStatus && this.reservationItem.acceptanceStatus.name === 'waitlisted' ) {
        return this.$t('orderPage.orderWaitList').toString()
      } else if(this.reservationItem && this.reservationItem.acceptanceStatus && this.reservationItem.acceptanceStatus.name === 'rejected') {
        return this.$t('orderPage.orderRejected').toString()
      }else if(this.reservationItem && this.reservationItem.acceptanceStatus && this.reservationItem.acceptanceStatus.name === 'accepted') {
        return this.$t('orderPage.orderAccepted').toString()
      } else {
        return ''
      }
      return ''
    },

    getLabel (): string {
      if (this.reservationItem && this.reservationItem.status === 'active') {
        return this.$t('orderPage.reservationIsActiveMessage').toString()
      } else if(this.reservationItem && this.reservationItem.status === 'canceled') {
        return this.$t('orderPage.reservationIsCanceledMessage').toString()
      }else if(this.reservationItem && this.reservationItem.status === 'delivered') {
        return this.$t('orderPage.reservationWasAlreadyDeliveredMessage').toString()
      } else {
        return ''
      }
      return ''
    },

    isReservationCanceled (): boolean {
      if(this.reservationItem && this.reservationItem.acceptanceStatus && this.reservationItem!.acceptanceStatus.name) {
        return true
      } else {
        return false
      }
    },

    getConfig (): string {
      if (this.reservationItem && this.reservationItem.status === 'active') {
        return 'fas fa-check-circle'
      } else if(this.reservationItem && this.reservationItem.status === 'canceled') {
        return 'fas fa-minus-square'
      }else if(this.reservationItem && this.reservationItem.status === 'delivered') {
        return 'fas fa-cookie-bite-circle'
      } else {
        return ''
      }
      return ''
    },

    getIcon (): string {
      if (this.reservationItem && this.reservationItem.acceptanceStatus && this.reservationItem.acceptanceStatus.name === 'waitlisted' ) {
        return 'fas fa-clock'
      } else if(this.reservationItem && this.reservationItem.acceptanceStatus && this.reservationItem.acceptanceStatus.name === 'rejected') {
        return 'fas fa-times-circle'
      }else if(this.reservationItem && this.reservationItem.acceptanceStatus && this.reservationItem.acceptanceStatus.name === 'accepted') {
        return 'fas fa-check-circle'
      } else {
        return ''
      }
      return ''
    },

    getColor (): string {
      if (this.reservationItem && this.reservationItem.status === 'active') {
        return 'green'
      } else if(this.reservationItem && this.reservationItem.status === 'canceled') {
        return 'red'
      }else if(this.reservationItem && this.reservationItem.status === 'delivered') {
        return '#8fa2c3'
      } else {
        return ''
      }
      return ''
    },

    isKioskMode (): boolean {
      return this.$store.getters[GET_MODE] === 'kiosk'
    },

    dateLabel (): string {
      return moment(this.date)
        .locale(getLocale())
        .format('dddd D.M YYYY').toLocaleLowerCase()
    },

    saveButtonIcon (): string {
      if (this.reservationItem && this.reservationItem.status === 'canceled') {
        return 'fas fa-undo'
      }

      return 'fas fa-save'
    },

    saveButtonLabel (): TranslateResult | undefined {
      if (!this.reservationItem) {
        return this.$t('orderPage.placeNewReservationButtonLabel')
      } else if (this.reservationItem && this.reservationItem.status === ReservationStatus.active) {
        return this.$t('orderPage.changeReservationButtonLabel')
      } else if (this.reservationItem && this.reservationItem.status === ReservationStatus.canceled) {
        return this.$t('orderPage.restoreReservationButtonLabel')
      }

      return undefined
    },

    saveButtonMinHeight (): number | undefined {
      if (this.$vuetify.breakpoint.smAndDown) {
        return 80
      }

      return undefined
    },

    saveButtonMinWidth (): string | undefined {
      if (this.$vuetify.breakpoint.smAndDown) {
        return '100%'
      }

      return undefined
    },

    isSaveButtonDisabled (): boolean {

      if (this.cancellationInProgress) {
        return true
      }

      if (this.reservationItem && this.reservationItem.status === ReservationStatus.active) {
        return !(this.isSelectionChanged || this.isAmountChanged)
      }else if(!this.timeBlockCollection) {
        return true
      }else if(this.isOfferEmpty){
        return true
      }
      return false
    },

    isCancelButtonDisabled (): boolean {
      return this.saveInProgress
    },

    allowSave (): boolean {
      if (this.reservationItem && (['active', 'canceled'].includes(this.reservationItem.status))) {
        return true
      } else if (!this.reservationItem) {
        return true
      }

      return false
    },

    allowCancellation (): boolean {
      return this.reservationItem && this.reservationItem.status === ReservationStatus.active || false
    }
  },

  methods: {
    closeRatingDialog () {
      this.showRatingDialog = false
      this.$emit('update')
    },

    showRatingDialogClick () {
      this.showRatingDialog = true
    },
    // <editor-fold desc="Event handlers">
    onSaveButtonClick (): void {
      if (this.reservationItem && this.reservationItem.status === 'active') {
        this.$emit('changeReservationClick')
      } else if (this.reservationItem && this.reservationItem.status === 'canceled') {
        this.$emit('restoreReservationClick')
      } else {
        this.$emit('placeNewReservationClick')
      }
    },

    showInformationDialog(): void {
      this.showInfoDialog = true
    },

    onCancelButtonClick (): void {
      this.$emit('cancelReservationClick')
    },
    // </editor-fold>
  },
  mounted() {
  }
})
</script>

<style lang="stylus" scoped>
.button-Style {
  position fixed
  bottom 22px
}

.button-Style2 {
  position fixed
  bottom 22px
  right 310px
}

.button-Style1 {
  position fixed
  bottom 22px
  right 30px
}

.btn-77 {
  -webkit-animation: pulse 1.5s infinite;
  animation: pulse 1.5s infinite;
  border-radius: 50px;
  box-shadow: 0 0 0 0.5em transparent;
  padding: 1 1 1 1 ;
  position: relative;
}
@-webkit-keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 red;
  }
}
@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 red;
  }
}

.pulse-button {
  border: none
  border-radius: 50%
  background: #b4dab7
  cursor: pointer
  box-shadow: 0 0 0 0 rgba(180, 199, 218, 0)
  transform: scale(1)
  animation: pulse 1s infinite
}

@keyframes pulse {
  0% {
    transform: scale(0.9)
  }
  70% {
    transform: scale(1)
    box-shadow: 0 0 0 15px rgba(180, 199, 218, 0)
  }
  100% {
    transform: scale(0.9)
    box-shadow: 0 0 0 0 rgba(180, 199, 218, 0)
  }
}
</style>
